<template>
  <div id="reset-password-request" class="flex column wrap justify-center grow-1">
    <div class="return-link flex column align-end">
      <nav class="flex column align-end">
        <router-link to="/" class="color-text">
          &lt; Iniciar sesión
        </router-link>
      </nav>
    </div>
    <form class="form flex column grow-1 align-start align-self-center justify-center justify-flex-start-sm">
      <h1>RESTABLECER ACCESOS</h1>
      <input
        @keypress.enter="submitLogin"
        type="password"
        id="password"
        name="password"
        placeholder="Nueva contraseña"
        class="text-input"
        v-model="password"
        required
      />
      <span
        v-if="errors.password.length"
        class="error"
      >
        {{ errors.password[0] }}
      </span>
      <input
        @keypress.enter="submitLogin"
        type="password"
        id="password_confirmation"
        name="password_confirmation"
        placeholder="Confirma la nueva contraseña"
        class="text-input"
        v-model="password_confirmation"
        autofocus
        required
      />
      <span
        v-if="errors.passwordConfirmation.length"
        class="error"
      >
        {{ errors.passwordConfirmation[0] }}
      </span>
      <div class="flex justify-space-evenly dspl-inline-grid-m dspl-inline-grid-sm justify-stretch-sm login-buttons">
        <button class="btn" @click.prevent="submitLogin">Enviar</button>
      </div>
      <ErrorModal
        @confirm="showErrorModal = false"
        :active="showErrorModal"
        message="La contraseña no se actualizó, solicite su contraseña nuevamente"
      />
      <SuccessModal
        @confirm="successModalConfirm"
        :active="showSuccessModal"
        message="Listo, información actualizada"
      />
    </form>
  </div>
</template>

<script>
import { resetPassword } from '@/api/users'
import ErrorModal from '@/components/ErrorModal'
import SuccessModal from '@/components/SuccessModal'

export default {
  name: 'PasswordRecovery',
  data () {
    return {
      showErrorModal: false,
      showSuccessModal: false,
      password: '',
      password_confirmation: '',
      errors: {
        password: [],
        passwordConfirmation: []
      }
    }
  },
  components: {
    ErrorModal,
    SuccessModal
  },
  methods: {
    successModalConfirm: function () {
      this.showSuccessModal = false
      this.$router.push('/')
    },
    cleanErrors () {
      this.errors = {
        password: [],
        passwordConfirmation: []
      }
    },
    submitLogin () {
      this.cleanErrors()

      if (this.password.length < 6) {
        this.errors = { ...this.errors, password: ['La nueva contraseña debe ser mayor a 6 caracteres'] }
      }
      if (this.password_confirmation.length < 6) {
        this.errors = { ...this.errors, passwordConfirmation: ['La confirmación de contraseña debe ser mayor a 6 caracteres'] }
      }
      if (this.password !== this.password_confirmation) {
        this.errors = {
          ...this.errors,
          password: [...this.errors.password, 'La nueva contraseña y la confirmación de contraseña deben coincidir'],
          passwordConfirmation: [...this.errors.passwordConfirmation, 'La nueva contraseña y la confirmación de contraseña deben coincidir']
        }
      }

      if (!this.errors.password.length && !this.errors.passwordConfirmation.length) {
        this.sendData()
      }
    },
    sendData: function () {
      const data = { reset_password_token: this.$route.params.password_token, password: this.password, password_confirmation: this.password_confirmation }

      resetPassword(data).then(() => {
        this.showSuccessModal = true
        this.password = ''
        this.password_confirmation = ''
      }).catch((_) => {
        this.password = ''
        this.password_confirmation = ''
        this.showErrorModal = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#reset-password-request {
  height: 100vh;
}

.form {
  width: 50%;
}

.return-link {
  width: 89%;
  margin-top: 8%;
}

.text-input {
  font-size: 1rem;
  padding: 0.8rem;
  border-radius: 20px;
  border-width: 0;
  width: 100%;
  margin: 15px 0;

  &:focus {
    outline-width: 0;
  }
}

input {
  font-size: 1em;
  padding: 0.8em;
  border-radius: 20px;
  border-width: 0;
  width: 100%;
  margin: 15px 0;

  &:focus {
    outline-width: 0;
  }
}

.btn {
  font-size: 0.8rem;
  background-color: $light-blue;
  border-radius: 20px;
  color: white;
  border: 0;
  padding: 0.6rem 1.5rem;
  margin: 12px 0;
  cursor: pointer;

  &:focus {
    outline-width: 0;
  }
}

.color-text {
  color: $blue;
  text-decoration: none;
}

.login-buttons {
  width: 100%;
}

.sentri-input {
  width: 100%;
  position: relative;

  .btn {
    position: absolute;
    top: 0;
    right: -1rem;
    margin: 20px 0px;
  }
}

.error {
  text-align: left;
  font-size: 0.75rem;
  color: $red;
}

@media screen and (max-width: 960px) {
  .form {
    width: 80%;
  }
}

@media screen and (max-width: 480px) {
  #reset-password-request {
    height: 75vh;
    min-height: 526px;
  }

  .form {
    width: 70%;
    margin: 5% 0 5% 0;
  }

  .nav {
    bottom: 5%;
  }
}
</style>
